import axios from "axios";
import { handleInvalidRequest } from "./usersBEClient";

export const base_url =
   process.env.REACT_APP_ENV === "test"
      ? "https://test.server.lecosy.com.mx/st"
      : process.env.NODE_ENV === "production"
      ? "https://server.lecosy.com.mx/st"
      : "http://localhost:8006";

const host = base_url;
const S3_STORAGE_ENDPOINT = host + "/s3_storage";

export const getPCFolderStructure = async () => {
   try {
      axios.defaults.withCredentials = true;
      const response = await axios.get(`${S3_STORAGE_ENDPOINT}/get/structure/folder/siroc`);
      return response.data.data;
   } catch (error) {
      handleInvalidRequest(error);
   }
};

export const createCompanyStructure = async (companyId) => {
   try {
      axios.defaults.withCredentials = true;
      const response = await axios.post(`${S3_STORAGE_ENDPOINT}/create/structure/folder/company`, { companyId });
      return response.data.data;
   } catch (error) {
      handleInvalidRequest(error);
   }
};

export const createPCStructure = async (companyId, folderName) => {
   try {
      axios.defaults.withCredentials = true;
      const response = await axios.post(`${S3_STORAGE_ENDPOINT}/create/structure/folder/pc`, {
         companyId: companyId,
         folderName: folderName,
      });
      return response.data.data;
   } catch (error) {
      handleInvalidRequest(error);
   }
};

export const createSirocStructure = async (companyId, folderName) => {
   try {
      axios.defaults.withCredentials = true;
      const response = await axios.post(`${S3_STORAGE_ENDPOINT}/create/structure/folder/siroc`, {
         companyId: companyId,
         folderName: folderName,
      });
      return response.data.data;
   } catch (error) {
      handleInvalidRequest(error);
   }
};

export const createYearStructure = async (companyId, folderName, year) => {
   try {
      axios.defaults.withCredentials = true;
      const response = await axios.post(`${S3_STORAGE_ENDPOINT}/create/structure/folder/siroc_by_year`, {
         companyId: companyId,
         folderName: folderName,
         year: year,
      });
      return response.data.data;
   } catch (error) {
      handleInvalidRequest(error);
   }
};

export const uploadDocument = async (bucket, filekey, binaryBlob, doc_type) => {
   try {
      axios.defaults.withCredentials = true;
      await axios.post(`${S3_STORAGE_ENDPOINT}/upload_file`, binaryBlob, {
         params: {
            bucket: bucket,
            filekey: filekey,
            doc_type: doc_type,
         },
      });
   } catch (err) {
      handleInvalidRequest(err);
   }
};

export const uploads3File = async (bucket, filekey, file, doc_type = "application/pdf") => {
   try {
      axios.defaults.withCredentials = true;
      axios.post(`${S3_STORAGE_ENDPOINT}/upload_file`, file, {
         headers: {
            "Content-Type": doc_type,
         },
         params: {
            bucket,
            filekey,
            doc_type,
         },
      });
   } catch (error) {
      handleInvalidRequest(error);
   }
};

export const getBucketSize = async (bucket: string, folder?: string) => {
   try {
      axios.defaults.withCredentials = true;
      const url = `${S3_STORAGE_ENDPOINT}/bucket-size/${bucket}`;
      const params = folder ? { folder } : undefined;
      const { data } = await axios.get(url, { params });
      return data;
   } catch (error) {
      handleInvalidRequest(error);
   }
};
